import { FormProvider, useForm } from 'react-hook-form';

import { Button, Grid, Stack } from '@mui/material';

import { FormRoot, RenderFormField } from '@/components';
import { withLoader, WithLoaderProps } from '@/hocs';
import { useFilesValidation } from '@/hooks';
import { IArrestFileForm, IUser } from '@/models';
import { uploadFiles } from '@/services';
import { useUserStore } from '@/store';

import { FileAcceptedTypes } from '../../KaseFiles/components/data';
import { useKaseArrestsContext } from '../KaseArrestsContext';

const ArrestFileForm = ({ showLoader, hideLoader }: WithLoaderProps) => {
  const { setArrestDrawer, currentArrestee, setCurrentArrestee } =
    useKaseArrestsContext();
  const { user } = useUserStore();
  const methods = useForm<IArrestFileForm>({
    defaultValues: {
      files: [],
    },
    mode: 'all',
  });

  const { handleSubmit, watch } = methods;

  const uploadedFileItems = watch('files');
  const hasInvalidFiles = useFilesValidation(uploadedFileItems);

  const onSubmit = async ({ files }: IArrestFileForm) => {
    if (!currentArrestee) {
      return;
    }

    showLoader();
    let newFiles = await uploadFiles(files);
    hideLoader();

    // Assign current user as `uploadedBy` value in Arrest files that are currently uploaded but not saved
    newFiles.forEach((file) => {
      file.uploadedBy = user as IUser;
    });

    if (!newFiles) return;

    if (currentArrestee?.files) {
      newFiles = newFiles.concat(currentArrestee.files);
    }

    setCurrentArrestee({
      ...currentArrestee,
      files: newFiles,
    });
    setArrestDrawer(null);
  };

  return (
    <FormProvider {...methods}>
      <FormRoot onSubmit={handleSubmit(onSubmit)}>
        <Grid container spacing={2}>
          <Grid xs={12} item>
            <RenderFormField
              name="files"
              label=""
              type="file"
              direction="vertical"
              enableEditDescription
              accept={FileAcceptedTypes}
            />
          </Grid>
        </Grid>
        <Stack flexDirection="row" p={2} justifyContent="flex-end" width="100%">
          <Button
            variant="contained"
            color="inherit"
            size="medium"
            sx={{ mr: 2 }}
            onClick={() => setArrestDrawer(null)}
          >
            Cancel
          </Button>
          <Button
            disabled={hasInvalidFiles}
            variant="contained"
            color="error"
            size="medium"
            onClick={handleSubmit(onSubmit)}
          >
            Save
          </Button>
        </Stack>
      </FormRoot>
    </FormProvider>
  );
};

export default withLoader(ArrestFileForm);
